import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'

const VideoExampleItem = ({
  title,
  description,
  customWidth,
  customHeight,
}) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  return (
    <div
      className="px24 py-2 rounded d-flex flex-column align-items-center text-center"
      style={{
        width: isMobile ? '100%' : customWidth ?? '100%',
        height: isMobile ? '100%' : customHeight ?? '100%',
        border: '1px solid rgba(0, 207, 131, 0.20)',
        background: '#FAFAFA',
      }}
    >
      <span className="text-on-bg-primary fw-bolder">{title}</span>
      <span className="fontSize14 text-on-bg-secondary mt-1">
        {description}
      </span>
    </div>
  )
}

export default VideoExampleItem
